import React, { useEffect, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import useAuth from 'src/hooks/useAuth';
import {
    handleGetPhoneAgencies,
    isWhatsappAvaible,
} from 'src/modules/store/helpers';
import { Duplicated } from 'src/components/Lead/Duplicated';
import useLead from 'src/hooks/useLead';
import { Statuses } from 'src/components/Lead/Statuses';
import { Reject } from 'src/components/Lead/Reject';
import { canReject } from 'src/components/Tasks/Modal/utils/canReject';
import { SendDocumentation } from 'src/components/Lead/Documentation';
import { SendWhatsApp } from 'src/components/Lead/WhatsApp';
import { isPluginAvailable } from 'src/utils/store/isPluginAvailable';
import { CALLS_PLUGIN, WSP_PLUGIN } from 'src/constants/plugins';
import { Evaluation } from 'src/components/Lead/Evaluation';
import {
    PREOWNEDS_LEAD_TYPE,
    DIGITAL_LEAD_TYPE,
    SHOWROOM_LEAD_TYPE,
    TAreas,
    NEWS_LEAD_TYPE,
} from 'src/constants/lead/leadTypes';
import {
    DEVELOPER_LEVEL_ACCESS,
    USER_LEVEL_ACCESS,
} from 'src/components/access';
import { AssignLead } from 'src/components/Lead/Assignation';
import { LeadContactedStatus } from 'src/components/Lead/Contacted';
import { ScheduleAppointment } from 'src/components/Lead/Appointments';
import { MakeCall } from 'src/components/Lead/Calls';
import { isPermissionGranted } from 'src/utils/permissions/isPermissionGranted';
import {
    AI_CALL_AUTH,
    PRESENTATION_CARD_AUTH,
    READ_PERMISSION,
    ASSIGN_AGENT_AUTH,
    UPDATE_PERMISSION,
    DUPLICATED_LEAD_AUTH,
} from 'src/constants/permissions';
import { MakeAICall } from 'src/components/Lead/AICall';
import { PresentationCard } from 'src/components/Lead/PresentationCard';
import { REJECTED, VISIT_REJECTED, STATUSES } from 'src/constants/mongo/status';
import { NEW_CARTYPE, PREOWNED_CARTYPE } from 'src/constants/user';
import useMailDocumentation from 'src/hooks/useMailDocumentation';
import useDocument from 'src/hooks/useDocument';
import { authorize } from 'src/utils/auth';

const useStyles = makeStyles((theme) => ({
    margin: {
        marginBottom: '1em',
    },
}));

export const LeadActions = () => {
    const { user } = useAuth();
    const { lead, loading } = useLead();
    const { getDocumentsLead } = useDocument();
    const { getMailDocumentationByStore, clearMailDocumentationState } =
        useMailDocumentation();
    const classes = useStyles();
    const isLeadRejected = () =>
        lead?.substatus?._id === REJECTED ||
        lead?.substatus?._id === VISIT_REJECTED ||
        lead?.status?._id === STATUSES.REJECTED.ID;

    const [type, setType] = useState<TAreas>();
    useEffect(() => {
        if (lead && lead._id) {
            getDocumentsLead(lead._id);
            if (lead.store)
                getMailDocumentationByStore(`&store=${lead.store._id}`);
            if (lead.type === DIGITAL_LEAD_TYPE) {
                if (lead.carType === NEW_CARTYPE) setType(NEWS_LEAD_TYPE);
                if (lead.carType === PREOWNED_CARTYPE)
                    setType(PREOWNEDS_LEAD_TYPE);
            } else setType(lead.type);
        }
        //eslint-disable-next-line
    }, [lead]);
    return (
        <Box>
            {lead?.type === SHOWROOM_LEAD_TYPE &&
                user.accessLevel !== USER_LEVEL_ACCESS && (
                    <Evaluation
                        className={classes.margin}
                        evaluation={lead?.evaluation}
                        lead={lead}
                    />
                )}

            <Statuses
                isDisabled={
                    !authorize(user?.accessLevel, DEVELOPER_LEVEL_ACCESS)
                }
                leadId={lead?._id}
                status={lead?.status?._id}
                substatus={lead?.substatus?._id}
                className={classes.margin}
            />
            {(canReject({
                permissions: user?.permissions || {},
            }) ||
                isLeadRejected()) && (
                <Reject
                    canReject={
                        !canReject({
                            permissions: user?.permissions || {},
                        }) || isLeadRejected()
                    }
                    isRejected={isLeadRejected()}
                    leadId={lead?._id}
                    hasVisits={lead?.visits?.length > 0}
                    className={classes.margin}
                />
            )}
            {isPermissionGranted({
                permissions: user?.permissions || {},
                permission: DUPLICATED_LEAD_AUTH,
                crud: READ_PERMISSION,
            }) && (
                <Duplicated
                    className={classes.margin}
                    leadId={lead._id}
                    duplicatedURL={lead.duplicatedURL}
                    isDuplicated={lead.isDuplicated}
                />
            )}

            <LeadContactedStatus
                className={classes.margin}
                isContacted={lead?.isContacted}
            />

            {isPermissionGranted({
                permissions: user?.permissions || {},
                permission: PRESENTATION_CARD_AUTH,
                crud: READ_PERMISSION,
            }) &&
                lead?.agent?.presentationCard && (
                    <PresentationCard
                        className={classes.margin}
                        presentationCard={lead?.agent?.presentationCard}
                    />
                )}

            <SendDocumentation lead={lead} className={classes.margin} />

            {lead?.store?.areas &&
                type &&
                isWhatsappAvaible({
                    area: type,
                    areas: lead?.store?.areas || [],
                }) &&
                isPluginAvailable(lead?.store, WSP_PLUGIN) && (
                    <SendWhatsApp lead={lead} className={classes.margin} />
                )}

            {isPermissionGranted({
                permissions: user?.permissions || {},
                permission: AI_CALL_AUTH,
                crud: READ_PERMISSION,
            }) && <MakeAICall className={classes.margin} />}

            {lead?.store?.areas &&
                type &&
                handleGetPhoneAgencies({
                    area: type,
                    areas: lead?.store?.areas || [],
                }).success &&
                isPluginAvailable(lead?.store, CALLS_PLUGIN) && (
                    <MakeCall className={classes.margin} />
                )}

            {lead && lead.visits && lead.visits.length === 0 && (
                <ScheduleAppointment className={classes.margin} />
            )}

            {isPermissionGranted({
                permissions: user?.permissions || {},
                permission: ASSIGN_AGENT_AUTH,
                crud: UPDATE_PERMISSION,
            }) && (
                <Box>
                    <AssignLead
                        area={lead?.type}
                        carType={lead?.carType}
                        storeId={lead?.store?._id}
                        leadId={lead?._id}
                        currentAgent={lead?.agent?._id}
                        className={classes.margin}
                        isPermissionGranted={true}
                    />
                </Box>
            )}
        </Box>
    );
};
